import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // This legacy interceptor is only needed because the Power BI APIM
  // endpoint validates the B2C id token. All other requests stay on the
  // normal MsalInterceptor path, including login and password reset.
  if (req.url !== environment.tokenPowerBI) {
    return next(req);
  }

  const authService = inject(MsalService);

  return from(
    authService.instance.acquireTokenSilent({
      scopes: [],
    }),
  ).pipe(
    switchMap(response => {
      //! SE DEBE ELIMINAR EL IF CUANDO ESTE LA CONSULTA DE LA INFORMACIÓN DE POWER BI A LA CAPA LÓGICA.
      if (!req.url.includes('api.powerbi.com')) {
        const token = response.idToken;

        if (token) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
      }
      return next(req);
    }),
  );
};
